/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// $(document).ready(function () {
//   // Smooth scroll to anchor, with option of hash appearing in the url

//   let offset = 120;

//   // Lower offset for mobile devices
//   if(window.screen.width < 479) {
//     offset = 65;
//   }
//   //Extra offset for collapsible review tab on product pages
//   if(window.location.href.includes('products')) {
//     offset = 180;
    
//     $('a[href="#looxReviews"]').on("click", () => {
//       $('#looxReviews').parent().parent().parent().prop('open', true);
//     });
//   };

//   $('a[href^="#"]:not([href="#"])').on("click", function (e) {
//     e.preventDefault();
//     var target = this.hash;
//     var $target = $(target);
//     // console.log($target.offset().top);
//     $("html, body")
//       .stop()
//       .animate(
//       {
//         scrollTop: $target.offset().top - offset, // subtracting for scroll padding
//       },
//       300,
//       "swing",
//       function () {
//         // window.location.hash = target
//       }
//     );
//   });
  
//   // Smooth scroll js ends

//   //Custom link functionalities
//   //CART PAGE
//   // $('.cart__button a.link').attr('href', 'javascript:window.history.back()') //Added link to kul-products in theme settings

//   //Custom link functionalities end

//   // Open PDFs in new page
//   var links = document.querySelectorAll(".c-btn, .list-menu__link");
//   links.forEach((link) => {
//     if (link.hostname !== window.location.hostname) {
//       link.target = "_blank";
//     }
//   });
//   // new page js for pdfs ends

//   //fancybox only for gallery, airflow and dampers, damper installation with specific settings
//   //Prevent clickable images on other pages

//   let options = {
//     Images: {
//       protected: true,
//     },
//     Hash: false,
//     fitToView: false,
//     Toolbar: {
//       display: {
//         left: ["infobar"],
//         middle: ["rotateCCW", "rotateCW"],
//         right: ["slideshow", "iterateZoom", "fullscreen", "thumbs", "close"],
//       },
//     },
//     Thumbs: {
//       showOnStart: false,
//     },
//     loop: false,
//   };

//   Fancybox.bind("[data-fancybox]", options);

//   Fancybox.bind("[data-fancybox='gallery']", options);

//   if (
//     !window.location.href.includes("gallery") &&
//     !window.location.href.includes("damper-installation") &&
//     !window.location.href.includes("airflow-dampers") &&
//     !window.location.href.includes("vent-cover-technical-specifications")
//   ) {
//     document.querySelectorAll(".fancybox__link").forEach((link) => {
//       link.removeAttribute("href");
//       link.removeAttribute("data-fancybox");
//     });
//   }
//   //fancybox only for gallery ends

//   //Add custom class for engraving final sale note
//   // let plates = [
//   //   "glacier-frost-1",
//   //   "stainless-steel",
//   //   "anodized-matte-black",
//   //   "anodized-matte-graphite",
//   //   "anodized-matte-gold",
//   // ];

//   // plates.forEach((plate) => {
//   //   if (window.location.href.includes(plate)) {
//   //     document.querySelector("div.product-form__add.js-product-buttons.product-form__add--dynamic").classList.add("engraving-note");
//   //   }
//   // });
//   //Adding custom class js ends

//   if(window.location.href.includes('product')) {
//     let dimensions = document.querySelectorAll('[thumbnail-alt]');
//     if(dimensions) {
//       dimensions.forEach(elm => {
//         if(elm.attributes[1].nodeValue !== '10 X 3') {
//           elm.classList.add('hide-image');
//         }
//       })
//     }

//     // if(window.location.href.includes('93255982')) {
//     //   document.querySelector('#shopify-section-template--20111597994271__main ul.thumbnail-list > li.thumbnail-list__item:nth-child(n + 8)').setAttribute('style', 'display: block');
//     //   document.querySelector('#shopify-section-template--20111597994271__main ul.thumbnail-list > li.thumbnail-list__item:nth-child(n + 13)').style.display = 'none';
//     // }
//   };

//   addEngravingNote();

//   showTooltip();
//   hideDocument();  
// });

document.addEventListener("DOMContentLoaded", function () {
  
  // ==========================================
  // 1. CONTENT-AWARE NATIVE SMOOTH SCROLLING
  // ==========================================
  document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const targetId = this.hash;
      
      // Handle the custom collapsible Loox Review accordion logic safely
      if (window.location.href.includes('products') && targetId === '#looxReviews') {
        const looxParent = document.querySelector('#looxReviews')?.closest('details');
        if (looxParent) {
          looxParent.open = true;
        }
      }
      
      // NO e.preventDefault() here. We let the modern browser natively handle
      // the scroll behavior using your CSS 'scroll-padding-top' parameters!
    });
  });

  // ==========================================
  // 2. FILE LINKS & PDF BEHAVIOR (NEW PAGE)
  // ==========================================
  const functionalLinks = document.querySelectorAll(".c-btn, .list-menu__link");
  functionalLinks.forEach((link) => {
    if (link.hostname !== window.location.hostname) {
      link.target = "_blank";
      link.rel = "noopener noreferrer"; // Performance and security safety best practice
    }
  });

  // ==========================================
  // 3. FANCYBOX INTERACTIVE LIGHTBOX ROUTING
  // ==========================================
  const fancyboxOptions = {
    Images: {
      protected: true,
    },
    Hash: false,
    fitToView: false,
    Toolbar: {
      display: {
        left: ["infobar"],
        middle: ["rotateCCW", "rotateCW"],
        right: ["slideshow", "iterateZoom", "fullscreen", "thumbs", "close"],
      },
    },
    Thumbs: {
      showOnStart: false,
    },
    loop: false,
  };

  if (typeof Fancybox !== 'undefined') {
    // Safely bind active elements
    Fancybox.bind("[data-fancybox]", fancyboxOptions);
    Fancybox.bind("[data-fancybox='gallery']", fancyboxOptions);
  }

  // Check if we are safely on an allowed page layout path
  const currentUrl = window.location.pathname; // Looks only at clean paths like /pages/gallery
  const allowedLayouts = ["gallery", "damper-installation", "airflow-dampers", "vent-cover-technical-specifications"];
  const isPageValid = allowedLayouts.some(path => currentUrl.includes(path));

  // ONLY strip attributes if we are 100% sure we are on an irrelevant catalog page
  if (!isPageValid) {
    document.querySelectorAll(".fancybox__link").forEach((link) => {
      link.removeAttribute("href");
      link.removeAttribute("data-fancybox");
    });
  }

  // ==========================================
  // 4. PRODUCT MEDIA DIMENSION FILTERING
  // ==========================================
  if (window.location.href.includes('product')) {
    const dimensions = document.querySelectorAll('[thumbnail-alt]');
    dimensions.forEach(elm => {
      // Safely check fallback attributes to protect structural layouts
      const altValue = elm.getAttribute('thumbnail-alt');
      if (altValue && altValue !== '10 X 3') {
        elm.classList.add('hide-image');
      }
    });
  }

  // ==========================================
  // 5. EXTERNAL MODULE INITIALIZATIONS
  // ==========================================
  if (typeof addEngravingNote === 'function') addEngravingNote();
  if (typeof showTooltip === 'function') showTooltip();
  if (typeof hideDocument === 'function') hideDocument();  
});

// $(window).on("load", function() {
//   showCurrencyCodesForCA();
// });

// async function to fetch country - can be used in future
// const fetchCountry = async () => {
//   await fetch(
//     window.Shopify.routes.root
//     + 'browsing_context_suggestions.json'
//     + '?country[enabled]=true'
//     + `&country[exclude]=${window.Shopify.country}`
//   ).then(r => r.json()).then(/* Custom code goes here */);
// };

// async function to fetch country ends

// function to updated currency codes for Canada Market
/**
 * This function is minified and added to VariantSelects class in theme.min.js.
 * Refer theme.js for relative placement and parts used of the function in theme.min.js
 * It's added in theme.js inside VariantSelects class (currently line 1135).
 */

// Backup original
// const originalAjaxCartLoad = ajaxCart.load;

// Wrap it
// ajaxCart.load = function(...args) {
//   // Call original cart load function
//   const result = originalAjaxCartLoad.apply(this, args);

//   // Wait a moment for DOM to update, then apply currency suffix
//   setTimeout(() => {
//     showCurrencyCodesForCA();
//   }, 100); // adjust delay if needed

//   return result;
// };


// function showCurrencyCodesForCA() {
//   // console.log('[CAD ADDED] Updating cart prices with CAD suffix');

//   // // commented function added in onVariantChange after this.renderProductInfo() (currently line 1102)
//   // if(window.location.href.includes('products')) {
//   //   if(document.querySelector('.product-single')) {
//   //     if(document.querySelector('#customer-info') && document.querySelector('#customer-info').getAttribute('data-market') === 'international') {
//   //       const priceContainer = document.getElementById(`price-${this.uniqueId}`); //this declaration is to be used inside VariantSelects class only

//   //       let productPrice = priceContainer.querySelector('.price__number .money');
//   //       productPrice.innerText = productPrice.innerText.concat(' CAD');
//   //     };
//   //   };
//   // }

//   //CART Drawer Fix - Ishan
//   if(document.querySelector('#customer-info') && document.querySelector('#customer-info').getAttribute('data-market') === 'international') {
    
//     const cartPriceItems = document.querySelectorAll('div.ajaxcart-draw__wrapper span.money');

//     if(cartPriceItems) {
//       cartPriceItems.forEach(item => {
//         item.innerText = item.innerText.concat(' CAD');
//       });
//     };
//   };
//   //CART Drawer Fix ENDS

// };

// function to updated currency codes for Canada Market ends

// function to add engraving-note on plates

function addEngravingNote() {
  if(window.location.href.includes('products') || window.location.href.includes('collections')) {
    if(document.querySelector('.product-single')) {
      if(document.querySelector(".product-personalizer")) {
        document.querySelector("div.product-form__add.js-product-buttons.product-form__add--dynamic").classList.add("engraving-note");
        let marketFee = '';
        let engravingNoteContainer = document.createElement('div');
        let engravingNotePara = document.createElement('p');

        

        if(document.querySelector('#customer-info') && document.querySelector('#customer-info').dataset.market === 'international') {
          marketFee = "$7 CAD";
        }
        else {
          marketFee = "$5.25 USD";
        };

        engravingNoteContainer.classList.add('custom-engraving-note');

        engravingNotePara.innerText = `*${marketFee} for custom engraving`;
        engravingNoteContainer.appendChild(engravingNotePara);

        const positionNode = document.querySelector('.product-single__box__block.product-single__box__block--quantity_selector');

        positionNode.after(engravingNoteContainer);

      };
    };
  };
};

function hideDocument() {
  if(window.location.href.includes('account')) {
    if(document.querySelector('#customer-info') && document.querySelector('#customer-info').getAttribute('data-market') === 'international') {
      const doumentsList = document.querySelectorAll('.document-item');

      doumentsList.forEach(doc => {
        let platesDocument = doc.getAttribute('title');

        if(platesDocument.toLowerCase().includes('plates')) {
          doc.classList.add('hidden');
        }
      });
      
    };
  };
};

function showTooltip() {
  if(window.location.href.includes('product')) {
    setTimeout(() => {
      let optionTitleContainer = document.querySelector('div.product-single__box__block.product-single__box__block--variant_picker variant-radios product-interactive-options fieldset:nth-child(2) div.product-form__swatch__title legend')
      if(optionTitleContainer && optionTitleContainer.innerText.toLowerCase().trim() === 'mounting holes') {
        document.querySelector('div.product-single__box__block.product-single__box__block--variant_picker variant-radios product-interactive-options fieldset:nth-child(2) div.product-form__swatch__title legend span.custom-tooltip').style.display = "inline-flex";
      };
    }, 1000);

    if(document.querySelector('div.product-single__box__block.product-single__box__block--variant_picker variant-radios product-interactive-options fieldset:nth-child(2) div.product-form__swatch__title legend span.custom-tooltip')) {
      document.querySelector('div.product-single__box__block.product-single__box__block--variant_picker variant-radios product-interactive-options fieldset:nth-child(2) div.product-form__swatch__title legend span.custom-tooltip').addEventListener('mouseenter', () => {
        document.querySelector('div.product-single__box__block.product-single__box__block--variant_picker variant-radios product-interactive-options fieldset:nth-child(2) div.product-form__swatch__title legend span.custom-tooltip span div.custom-tooltip-text').style.display = 'block';
      });

      document.querySelector('div.product-single__box__block.product-single__box__block--variant_picker variant-radios product-interactive-options fieldset:nth-child(2) div.product-form__swatch__title legend span.custom-tooltip').addEventListener('mouseleave', () => {
        document.querySelector('div.product-single__box__block.product-single__box__block--variant_picker variant-radios product-interactive-options fieldset:nth-child(2) div.product-form__swatch__title legend span.custom-tooltip span div.custom-tooltip-text').style.display = 'none';
      });
    };
  };
};